import React, { useEffect } from 'react';
import { FieldValues, RefCallBack, UseFormRegister, useForm, useFormContext } from 'react-hook-form';
import get from 'lodash/get';

interface IInputProps {
    name: string,
    id: string,
    label: string,
    placeholder: string,
    errors: any,
    register: any,
    readonly?: boolean,
    defaultValue?: string
    disabled?: boolean
    maxLength?: number,
    handleOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: any,
    isvalidateNumber?: boolean,
    isvalidateNumberPostalCode?: boolean,
    req?: string
    xl?: number
    md?: number
    col?: number
}

const InputHora: React.FC<IInputProps> = ({ name, id, label, placeholder, readonly, defaultValue, disabled, req, xl, md, col }) => {

    const { setValue, register, formState: { errors } } = useFormContext();
    const errorMessage = get(errors, name)?.message;
    useEffect(() => {
        setValue(name, defaultValue || "");
    }, []);

    return (
        <div className={`col-xl-${xl} col-md-${md} col-${col} input-block ${errors && errors[name]?.message ? 'error' : ''}`}>
            <label htmlFor={id} className="input-block__label">{label}</label>
            <input type="time" id={id} name={name}
            placeholder={placeholder} 
            {...register(name, { required: req })} 
            readOnly={readonly || false} 
            disabled={disabled || false} 
            defaultValue={defaultValue || ''} />
            {errorMessage && <p className="error m-0">{errorMessage}</p>}
        </div>
    )
}

export default InputHora;

// USE EXAMPLE
{/* <InputText 
  id="personalDataName"
  name="personalDataName"
  label="Nombre"
  placeholder="Nombre"
  errors={errors}
  register={register}
  req = 'MENSAJE DE ERROR CUANDO NO HAYA VALOR'
/> */}